<script setup lang="ts">
import { computed } from 'vue'
interface Props {
  blok: {
    html: string
    alignment: 'left' | 'center' | 'right'
  }
}
const { blok } = defineProps<Props>()
const alignmentClass = computed(() => {
  switch (blok.alignment) {
    case 'center':
      return 'flex justify-center text-center'
    case 'right':
      return 'flex justify-end text-right'
    default:
      return 'flex justify-start text-left'
  }
})
const safeHtml = computed(() => blok.html)
</script>

<template>
  <div class="html-block" :class="alignmentClass" v-html="safeHtml" />
</template>
